import { useMemo } from 'react'
import { z } from 'zod'
import { useSyncedState } from './useSyncedState'

// `defaultGroupBy` (comma-joined dims) seeds the group-by when ?groupby is absent — used by the
// Contribution decomposition seed (CONTRIBUTION_VIEWS). An explicit empty ?groupby (the
// fact-reset writes one) deliberately overrides the default -> [] (user/loud-reset wins).
export function useGroupByState(defaultGroupBy = ''): [string[], (next: string[]) => void] {
  const [raw, setRaw] = useSyncedState('groupby', z.string(), 'url', defaultGroupBy)
  // Stable array identity per raw string is load-bearing: downstream memo deps list groupBy
  // (useSeriesBaseLabels, useSeriesAdditivity) and would rebuild every render otherwise.
  const value = useMemo(() => (raw ? raw.split(',').filter(Boolean) : []), [raw])
  const setter = (next: string[]) => setRaw(next.join(','))
  return [value, setter]
}
